import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {AgentModel} from "../../models/agent.model";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";
import {UserNamePipe} from "../../../../commons/angular/pipes/user-name.pipe";

require('./agent-itinerary-link.scss');
@Component({
  standalone: false,
  selector: 'app-agent-itinerary-link',
  templateUrl: './agent-itinerary-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentItineraryLinkComponent implements OnInit, OnChanges {

  @Input() agent: AgentModel;
  @Input() agentId: string;
  @Input() agentName: string;
  @Input() linkToAgentView: boolean;
  @Input() isShowCopyButton: boolean;
  @Input() isShowFilterByButton: boolean;

  @Output() filterEvent = new EventEmitter<any>();

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public fullName: string;
  public hasDriversGetPermission: boolean;
  public isShowActions: boolean = false;


  constructor(@Inject(UserNamePipe) private userNamePipe: UserNamePipe) {
  }

  ngOnInit() {
    this.setAgentFullName();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      this.setAgentFullName();
    }
  }

  setAgentFullName() {
    if (this.agent) {
      this.fullName = this.userNamePipe.transform(this.agent.user || this.agent);
    }
  }

  filterByTypeEvent($event) {
    $event.stopPropagation();
    this.filterEvent.emit({type: this.siteFiltersType.agentIds, value: this.agent.id});
  }

}
